import { useContext } from "react";
import { PasswordlessContext } from "../../context/passwordless-context";

const usePasswordlessContext = () => {
	const context = useContext(PasswordlessContext);
	if (!context) {
		throw new Error("usePasswordlessContext must be used within PasswordlessContextProvider");
	}
	return context;
};

export default usePasswordlessContext;
